<template>
  <div class="mainWrapper">
    <!------------HTML Containers------------>
    <div
      class="container-fluid mainPageContainer"
      id="content-container"
      :style="loginImage"
    >
      <div class="row contaienrRow">
        <div class="col-md-4 marginLeft">
          <!------------Page Head---------------->
          <div class="pageHead">
            <h3>
              Interactive
              <b>Research</b>
            </h3>
          </div>
          <!---------Login Form---------------->
          <div class="loginContainer shadow-lg p-3 mb-5 rounded">
            <div class="col-md-12 text-center mb-3 mt-5">
              <span id="loginText" class="logoutTitle">Thank You.</span>
            </div>
            <div class="logoutText col-md-12 text-center mb-3">
              <p>
                You are now logged out!!
                <br />Please
                <!--<a href="/">Click Here</a> to login again.-->
                <!--<router-link :to="{ name: 'Login'}">Click Here</router-link> to login again.-->
                <router-link to="/" v-slot="{ href, navigate }">
                  <a :href="href" @click="navigate"> Click Here</a>
                </router-link>
                to login again.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Import Images
import bgImage from "@/assets/img/dbTiles/login.png";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Logout",
  data() {
    return {
      loginImage: {
        backgroundImage: "url(" + bgImage + ")",
      },
    };
  },
  methods: {
    ...mapActions(["logout"]),
  },
  mounted() {
    this.logout();
    localStorage.clear();
    sessionStorage.clear();
  },
};
</script>

<style lang="scss">
/*********************Page Background************************/
.mainWrapper {
  height: 100%;
}

.mainPageContainer {
  position: relative;
  background-size: cover;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

/**********************Login Container***************************/

.contaienrRow {
  margin-top: 9rem !important;
  position: relative;
  height: 100%;
}

.col-md-4 {
  height: 100%;
}

.marginLeft {
  margin-left: 10rem !important;
}

.pageHead h3 {
  color: $color-white;
  text-align: center;
  font-size: 35px;
}

.loginContainer:before {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  left: 50%;
  margin-left: -20px;
  margin-top: -65px;
  border: 20px solid transparent;
  border-bottom: 30px solid rgb(236, 236, 236);
}

.loginContainer {
  margin: 70px auto;
  width: 293px;
  min-height: 283px;
  background-image: linear-gradient(0deg, #cccccc 0%, #ffffff 100%);
  border: 1px solid rgba(158, 158, 158, 0.4);
}

.loginError {
  color: $color-red;
  font-size: 12px;
  left: 0;
  margin-bottom: 0 !important;
}

/**********************Login Form***************************/

.loginContainer h3 {
  text-align: center;
  font-size: 20px;
  color: $color-dark-grey;
  font-family: "Arial";
}

.loginContainer hr {
  width: 252px;
  height: 1px;
  filter: drop-shadow(0px 1px 0px $color-white);
  background-color: #acacac;
}

/*******************Logout**********************/

.logoutText {
  span,
  a {
    font-weight: bold;
    color: $base-color;
  }

  position: relative;
  margin-top: 20%;
  color: #000;
  font-size: 2.3 vh;
  font-family: sans-serif;
}

.logoutTitle {
  font-weight: normal;
  font-size: 5vh;
  color: $color-dark-grey;
}
</style>
